import {
  TableCell,
  TableRow,
} from "@/components/ui/table"

export const EmptyTableRow = (
  { numberOfColumns }: { numberOfColumns: number }
) => {

  return (
    <TableRow>
      <TableCell
        colSpan={numberOfColumns}
        className="h-24 text-center"
      >
        No results.
      </TableCell>
    </TableRow>
  )
}
